export enum TableState {
	free = 'free',
	unconfirmed = 'unconfirmed',
	approved = 'approved',
	taken = 'taken',
}
